import { useState } from "react";
import { MemberPortalTabs } from "./MemberPortalTabs";
import { memberStatusLabel } from "./memberPortalUtils";

export function MemberWorkspaceShell({
  activeTab,
  children,
  displayName = "",
  member = null,
  memberAccountLabel = "",
  memberAccountDetail = "",
  signupIntent = null,
  selectedTab = null,
  tabs = []
}) {
  const [memberMenuOpen, setMemberMenuOpen] = useState(true);
  const memberState = member
    ? member.status === "active"
      ? "Active member"
      : memberStatusLabel(member.status)
    : signupIntent?.paymentStatus === "paid"
      ? "Payment received"
      : signupIntent
        ? "Signup in progress"
        : "Membership not connected";
  const planName = member?.membershipPlan?.name || signupIntent?.membershipPlan?.name || "No active plan shown";

  return (
    <section className={`member-workspace-shell ${memberMenuOpen ? "" : "is-member-menu-collapsed"}`} aria-label="Member workspace">
      <header className="member-workspace-header">
        <button
          type="button"
          className="workspace-nav-toggle member-workspace-nav-toggle"
          onClick={() => setMemberMenuOpen((current) => !current)}
          aria-expanded={memberMenuOpen}
          aria-label={memberMenuOpen ? "Hide member apps" : "Show member apps"}
        >
          <span />
          <span />
          <span />
        </button>
        <div className="member-workspace-title-row">
          <span className="application-icon" aria-hidden="true">
            <span>{selectedTab?.icon || selectedTab?.label?.slice(0, 1) || "M"}</span>
          </span>
          <div>
            <span className="public-section-kicker">{selectedTab?.detail || "Member workspace"}</span>
            <h2>{selectedTab?.label || "Member portal"}</h2>
            <p>
              {selectedTab?.workspaceCopy || "Use this workspace for the member actions and information tied to this range."}
            </p>
          </div>
        </div>
        <div className="member-workspace-summary">
          <div>
            <span>Status</span>
            <strong>{memberState}</strong>
          </div>
          <div>
            <span>Plan</span>
            <strong>{planName}</strong>
          </div>
          <div>
            <span>Signed in</span>
            <strong>{memberAccountLabel || "Member account"}</strong>
            {memberAccountDetail && <small>{memberAccountDetail}</small>}
          </div>
        </div>
      </header>
      {memberMenuOpen && (
        <aside className="member-workspace-sidebar">
          <div className="member-workspace-sidebar-header">
            <span className="public-section-kicker">Member apps</span>
            <strong>{displayName}</strong>
          </div>
          <MemberPortalTabs activeTab={activeTab} tabs={tabs} />
        </aside>
      )}
      <div className="member-workspace-content">
        {children}
      </div>
    </section>
  );
}
